module.exports = __webpack_public_path__ + "img/PenaltyShootout.d0a95bfd.png";